import { t } from 'ember-intl';
import { variation } from 'ember-launch-darkly';
import { BreadcrumbsItem } from 'core/components';

<template>
  <BreadcrumbsItem
    @route="cloud.orgs.detail.projects.detail.hvns.list"
    @text={{t "components.page.hvns.list.title-short"}}
  />

  <BreadcrumbsItem
    @route="cloud.orgs.detail.projects.detail.hvns.detail.index"
    @text={{@controller.model.network.id}}
  />

  {{#unless (variation "hcp-hvn-guided-flow")}}
    <BreadcrumbsItem
      @route="cloud.orgs.detail.projects.detail.hvns.detail.transit-gateway-attachments.list"
      @text={{t "components.page.hvn-transit-gateway-attachments.list.title"}}
    />
  {{/unless}}

  {{outlet}}
</template>
